if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;


			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qtyMinus.addEventListener('click', (e)=>{
				qty.value
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					// if ( currentQty - 1 <= qtyMin ) {
					// 	qtyMinus.classList.add('disabled');
					// }
				}
				qty.dispatchEvent(new Event("change"))
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						// qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
				qty.dispatchEvent(new Event("change"))
			});
			qty.addEventListener("change", (e)=> {
				if (document.querySelector(".product__quantity-buttons")) {
					this.checkDiscount()
					document.querySelector("[data-js-product-price-compare]").style.display = "none"
				}
			})
			if (document.querySelector(".product__quantity-buttons")) {
				this.setDiscountListener()
			}
		}
		checkDiscount(){
			const discountsElement = document.querySelector(".product__quantity-buttons")
			const priceElement = document.querySelector("[data-js-product-price-original]")
			if (priceElement){
				this.setCurrentDiscount(discountsElement.getAttribute("data-origin-price"), priceElement )
			}
		}
		setCurrentDiscount(value, element){

			if (value == "" || value == "null"){
				return;
			}
			const discountsData = JSON.parse(document.querySelector("#discountObjects").innerHTML || false)
			const productQuantity = document.querySelector("product-quantity input")
			if (discountsData == false && !productQuantity){
				return
			}
			const discountCompare = document.querySelector("[data-js-product-price-compare-quantity]")
			const discountSave = document.querySelector("[data-js-product-price-saving-quantity]")
			let currentDiscount = discountsData.filter(discount => +discount.quantity <= +productQuantity.value).sort(function(a, b) {
				return Number(a.value.replace("%", "")) - Number(b.value.replace("%", ""));
			}).at(-1)



			if (!currentDiscount){
				element.innerHTML = this._formatMoney(value, KROWN.settings.shop_money_format)
				discountCompare.innerHTML = ""
				discountSave.classList.remove("active")
				return;
			}
			discountSave.classList.add("active")
			discountSave.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this._formatMoney(value * +productQuantity.value - (value - (value / 100 * Number(currentDiscount.value.replace("%", ""))))* +productQuantity.value, KROWN.settings.shop_money_format))}</span>`
			discountCompare.innerHTML = this._formatMoney(value * +productQuantity.value, KROWN.settings.shop_money_format)
			element.innerHTML = this._formatMoney((value - (value / 100 * Number(currentDiscount.value.replace("%", ""))))* +productQuantity.value, KROWN.settings.shop_money_format)

		}
		_formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);

		}
		setDiscountListener(){
			const qty = this.querySelector('.qty-selector')
			let discountButtons = document.querySelectorAll(".product__quantity-button")

			discountButtons.forEach(discountButton => {
				discountButton.addEventListener("click", ()=> {
					discountButtons.forEach(subDiscountButton => {
						subDiscountButton.classList.remove("active")
					})
					qty.value = +discountButton.getAttribute("data-discount-quantity")
					qty.dispatchEvent(new Event("change"))
					discountButton.classList.add("active")
				})
			})
		}
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}